import './styles.css';

export default function RoundStatusToggle({ isActive = false, onChange }) {
  return (
    <label className="round-status-toggle">
      <input
        type="checkbox"
        checked={isActive}
        onChange={(e) => onChange(e.target.checked)}
      />
      <span className="round-status-toggle-slider">
        <span>{isActive ? 'Live' : 'Closed'}</span>
      </span>
    </label>
  );
}
